import { render, staticRenderFns } from "./SH040ShopperTdkInfoGift.vue?vue&type=template&id=18002692&"
import script from "./SH040ShopperTdkInfoGift.vue?vue&type=script&lang=js&"
export * from "./SH040ShopperTdkInfoGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports